import { dataFileEdit } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFileEdit = /*#__PURE__*/createIcon(dataFileEdit)
export default IconFileEdit
